import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { environment } from 'environments/environment';

import { AppConfiguration } from './app-configuration.model';

@Injectable()
export class AppConfigurationService {
    protected config: AppConfiguration = environment.configuration as AppConfiguration;
    private configurationLoaded$: ReplaySubject<boolean>;

    constructor() {
        this.configurationLoaded$ = new ReplaySubject<boolean>(1);
    }

    get configuration(): AppConfiguration {
        return this.config;
    }

    loadConfiguration() {
        this.configurationLoaded$.next(!!this.config);
    }

    get configurationLoaded(): Observable<boolean> {
        return this.configurationLoaded$.asObservable();
    }
}
